import types from '../../constants';

const initialState = {
  loading: false,
  exercise: {},
  benchmark: null,
  playCurTime: 0,
};

const ExerciseReducers = (state = initialState, action) => {
  let users;
  switch (action.type) {
    case types.EXERCISE_LOAD:
      return {
        ...state,
        exercise: action.payload,
      };
    case types.EXERCISE_UPDATE:
      return {
        ...state,
        exercise: {
          ...state.exercise,
          users: action.payload,
        },
      };
    case types.EXERCISE_USER_JOINED:
      users = (state.exercise.users || []).slice();
      users.push(action.payload);

      const userAlreadyInTheRoom = (state.exercise.users || []).some(
          user => user.id === action.payload.id);

      if (userAlreadyInTheRoom) {
        return state;
      }

      return {
        ...state,
        exercise: {
          ...state.exercise,
          users,
        },
      };
    case types.EXERCISE_USER_LEFT:
      users = (state.exercise.users || []).filter(
        user => user.id !== action.payload.id);

      return {
        ...state,
        exercise: {
          ...state.exercise,
          users,
        },
      };
    case types.EXERCISE_RENAME_USER:
      users = (state.exercise.users || []).map((user) => {
        if (user.id === action.payload.id) {
          user.name = action.payload.name;
        }

        return user;
      });

      return {
        ...state,
        exercise: {
          ...state.exercise,
          users,
        },
      };
    case types.EXERCISE_STATUS_CHANGE:
      return {
        ...state,
        exercise: {
          ...state.exercise,
          status: action.payload,
        },
      };
    case types.EXERCISE_USER_STATUS_CHANGE:
      users = (state.exercise.users || []).map((user) => {
        if (user.id === action.payload.id) {
          user.status = action.payload.status;
        }

        return user;
      });

      return {
        ...state,
        exercise: {
          ...state.exercise,
          users,
        },
      };
    case types.EXERCISE_LOADING_START:
      return {
        ...state,
        loading: true,
      };
    case types.EXERCISE_LOADING_END:
      return {
        ...state,
        loading: false,
      };
    case types.EXERCISE_LOCATION_UPDATE:
      users = (state.exercise.users || []).map((user) => {
        if (user.id === action.payload.id) {
          user.location = action.payload.location;
        }

        return user;
      });

      return {
        ...state,
        exercise: {
          ...state.exercise,
          users,
        },
      };
    case types.EXERCISE_SET_VAR:
      const variables = state.exercise.variables;
      variables[action.payload.key] = action.payload.value;

      return {
        ...state,
        exercise: {
          ...state.exercise,
          variables,
        },
      };
    case types.EXERCISE_SET_STATE:
      return {
        ...state,
        exercise: {
          ...state.exercise,
          state: action.payload,
        },
      };
    case types.EXERCISE_PLAY_START:
      return {
        ...state,
        exercise: {
          ...state.exercise,
          playStartedAt: new Date().getTime(),
          playTime: action.payload.playTime
        },
        playCurTime: action.payload.playTime
      };
    case types.EXERCISE_PLAY_PAUSE:
      return {
        ...state,
        exercise: {
          ...state.exercise,
          playStartedAt: null,
          playTime: action.payload.playTime
        },
        playCurTime: action.payload.playTime
      };
    case types.EXERCISE_PLAY_UPDATE_TIME:
      let playCurTime = state.exercise.playTime + new Date().getTime() - state.exercise.playStartedAt;

      return {
        ...state,
        playCurTime
      };
    case types.EXERCISE_CLEAR:
      return initialState;
    case types.EXERCISE_SET_BENCHMARK:
      return {
        ...state,
        benchmark: action.payload
      }
    default:
      return state;
  }
};

export default ExerciseReducers;
